import request from "root/js/request";

export const getParsersSocialPostsSubjects = async ({
  source__in,
  account_name_hash__in,
  brand_id__in,
  product_id__in,
  //
  limit,
  offset,
  search,
  ...rest
}) => {
  const response = await request({
    url: `parsers/social/posts/subjects/`,
    method: "get",
    params: {
      source__in,
      account_name_hash__in,
      brand_id__in,
      product_id__in,
      //
      limit,
      offset,
      search,
      ...rest,
    },
  });
  return response.data;
};
